<template>
    <div class="accountGroupSearch">
        <Row :gutter="4">
            <!-- 公司 -->
            <div v-if="companyId==1">
                <Col span="4">
                    <Select v-model="companyIds" @on-change="companyIdChange(companyIds)" :placeholder="$t('alarms.common.pleaseSelectCompany')">
                        <Option value="">{{ $t('configuration_management.common.cloudType') }}</Option>
                        <Option v-for="item in companyIdList" :value="item.id" :key="item.id">{{ item.companyName}}</Option>
                    </Select>
                </Col>
            </div>
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="accountGroupSearchKey" :placeholder="$t('RIAccountGroupManagement.queryByAccountGroupName')" @on-search="searchAccountGroup()"/>
            </Col>

            <Col span="4">
                <add-account-group></add-account-group>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddAccountGroup from '../account_group/AddAccountGroup'
    import TableAccountGroup from '../account_group/TableAccountGroup'
    var tableAccountGroup = TableAccountGroup;
    export default {
        name: 'AccountGroupSearch',
        components: {
            AddAccountGroup
        },
        data () {
            return {
                companyId:getCookie(global.companyId),
                accountGroupSearchKey:'',
                accountGroupSearchName:'',
                companyIds:'',
                companyIdList:[] // 公司
            }
        },
        mounted(){
            this.listRegisterInformation();
        },
        methods: {
            searchAccountGroup: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('accountGroupSearchName', this.accountGroupSearchKey);
                tableAccountGroup.methods.showAll();
            },
            // 公司
            listRegisterInformation: function () {
                this.$api.user.listRegisterInformation()
                .then(res => {
                    // 获取公司列表数据
                    this.companyIdList = res.data.companies;
                })
            },
            // 切换公司
            companyIdChange:function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyIds', this.companyIds);
                tableAccountGroup.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .accountGroupSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/AccountGroupSearch.vue